import React, { useState, useEffect } from 'react';
import "./OrderSummary.css";
import OrderItem from '../OrderItem/OrderItem';
import { useSelector } from 'react-redux';

export default function OrderSummary(props) {
  const cart = props.cart;
  const [lineItems, setLineItems] = useState(props.cartItems);

  useEffect(() => {
    if (props.cartItems) {
      setLineItems(props.cartItems)
    }
  }, [props.cartItems])

  function list() {
    if (Object.keys(cart).length !== 0 && lineItems) {
      return (
        <div className='OrderList'>
          {
            lineItems?.map((item, index) => {
              return (
                <OrderItem key={index} item={item} />
              );
            })
          }
          <div className="RowPadding"></div>
        </div>
      )
    }
  };

  return (
    <div >
      {list()}
    </div>
  )
};

